export const SUSY_LOCALSTORAGE_UILANGUAGE_KEY = 'susyUILanguage';
